import { AdvertisingService } from 'data/services/advertising';
import { AdvertisingServiceInterface } from 'domain/services';
import { makeAdvertisingCreate } from 'main/factories/usecases/advertising/remote-advertising-create-factory';
import { makeAdvertisingDelete } from 'main/factories/usecases/advertising/remote-advertising-delete-factory';
import { makeAdvertisingList } from 'main/factories/usecases/advertising/remote-advertising-list-factory';
import { makeAdvertisingUpdate } from 'main/factories/usecases/advertising/remote-advertising-update-factory';

export const makeAdvertisingService = (): AdvertisingServiceInterface => {
  return new AdvertisingService(
    makeAdvertisingUpdate(),
    makeAdvertisingCreate(),
    makeAdvertisingList(),
    makeAdvertisingDelete(),
  );
};
